import {
  apiClient,
  type ShipmentOrderInputHistoryDetailEntity
} from '@/libs/api'

export type FetchShipmentOrderHistoryQuery = {
  tenantKey: string
  id: number
}

export type FetchShipmentOrderHistoryResponse = {
  data: ShipmentOrderInputHistoryDetailEntity
}

// 配送依頼履歴詳細取得API
export const fetchShipmentOrderHistory = async (
  { tenantKey, id }: FetchShipmentOrderHistoryQuery,
  signal?: AbortSignal
): Promise<FetchShipmentOrderHistoryResponse> => {
  const data = await apiClient
    ._tenant(tenantKey)
    .shipment_orders.histories._id(id)
    .$get({
      config: {
        signal
      }
    })
  return {
    data: data.data
  }
}
